
<ng-container *ngIf="tokenData;else no_token_act">
    <div class="row m-0 h-100 row-container">
        <div *ngIf="tokenData['role'] == 'employer'" class="col-formed-side pe-0 ps-0 section-side-nav h-100 d-none d-lg-block">
            <app-sidebar></app-sidebar>
          </div>
          <div [ngClass]="tokenData['role'] == 'employer' ? 'col-formed-main' : ''" class=" big-area wrap-container p-0">
            <router-outlet></router-outlet>
            </div>
        </div>
</ng-container>
<ng-template #no_token_act>
    <router-outlet></router-outlet>
</ng-template>
